import React, { useEffect } from "react";
import { GrowthBook, GrowthBookProvider as GBProvider } from "@growthbook/growthbook-react";
import { getEnv } from "../EnvironmentTools";
import { getCurrentLanguage, getStoreId } from "../BasePathTools";
import { getTarget } from "./utils";
import { getAppVersion } from "../eventsBus";
import appState from "src/model/state";



export const GrowthBookProvider = ({ children }: { children: React.ReactNode }) => {
  const growthbook = new GrowthBook({
    apiHost: getEnv()?.growthBookHost,
    clientKey: getEnv()?.growthBookClientKey,
    decryptionKey: getEnv()?.growthBookDescriptionKey,
    enableDevMode: true,
  });

  useEffect(() => {
    const initGrowthBook = async () => {
      try {
        const gbInit  = await growthbook.init({ streaming: true });
        if(!!gbInit.error){
          errorHandle(gbInit.error)
        }
        growthbook.setAttributes({
          "storeId": getStoreId()?.toString(),
          "langCode": getCurrentLanguage(),
          "target": getTarget(),
          "version": getAppVersion(),
        });

      } catch (error) {
         errorHandle(error)
      }
    };
    initGrowthBook();

  }, [growthbook]);


  const errorHandle = (error) => {
    appState.execute("GROOWTHBOOK_ERROR_SET", error);
    console.error("❌ Error initializing GrowthBook:", error);
  }

  
    return <GBProvider growthbook={growthbook}>{children}</GBProvider >;
  };